<template>
  <div>
    <div class="header">
      <img src="../assets/logo.png" alt=""/>
      <div class="language-switcher">
        <button
          v-for="lang in languages"
          :key="lang"
          type="button"
          :class="['language-button', { active: currentLocale === lang }]"
          @click="changeLanguage(lang)"
        >
          {{ lang.toUpperCase() }}
        </button>
      </div>
    </div>
    <router-view/>
  </div>
</template>
<script>
export default {
  data: () => ({
    languages: ['pt', 'en', 'es'],
  }),
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
    },
  },
}
</script>
<style>
.header {
  height: 80px;
  background: #3f0c29;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
}

.language-switcher {
  position: absolute;
  right: 16px;
  display: flex;
  gap: 4px;
}

.language-button {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: #ffffff;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.language-button.active {
  background: #ffffff;
  color: #3f0c29;
  border-color: #ffffff;
}
</style>
